module.exports = __webpack_public_path__ + "static/media/selling-water-table-service-02.e10d75ac.jpg";